import { Button, Card, FormControl, FormHelperText, FormLabel, Textarea, useToast, Table, Thead, Tr, Th, Tbody, Td, Modal, ModalOverlay, ModalContent, ModalHeader, ModalBody, ModalFooter, useDisclosure, Input } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import Axios from "../utils/httpClient";  
import KpiMiniTable from "./KpiMiniTable";

const AppCreate = ({getApps, fromWelcome = false}) => {
    const toast = useToast();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState({});
    const [obj, setObj] = useState({});
    const [categories, setCategories] = useState([]);
    const { isOpen, onOpen, onClose } = useDisclosure();
    const [selectedParam, setSelectedParam] = useState(null);
    const [files, setFiles] = useState([]);

    useEffect(()=>{
        Axios().get('api/v1/application/kpi-parameters/')
        .then(res=>{
            setCategories(res?.data?.categories||[]);
        })
        .catch(()=>{})
    },[])

    const openApply = (param) => {
        setSelectedParam(param);
        setObj({work: ''});
        setFiles([]);
        setError({});
        onOpen();
    }

    const createApp = (e) => {
        e.preventDefault();
        setLoading(true);
        let t = true, err= {};
        if(!obj?.work){
            t = false;
            err={...err, work: true}
        } 
        if(!selectedParam){
            t=false;
            err={...err, parameter: true}
        }
        if(t){
            const form = new FormData();
            form.append('work', obj?.work||'');
            form.append('parameter_id', selectedParam?.id);
            for(const f of files){
                form.append('files', f);
            }
            Axios({multipart: true}).post('api/v1/application/create/', form)
            .then(res=>{   
                toast({
                    title: 'Yuborildi.',
                    description: "Ko'rib chiqishga yuborildi.",
                    status: 'success',
                    duration: 9000,
                    isClosable: true,
                    position: 'top'
                });
                getApps();
                setObj({});
                onClose();
            }).catch(e=>{ 
                setError({common_e: "Bajarilgan ishni kiritib bo'lmadi."})
            }).finally(()=>{
                setLoading(false);
            })
        }else{
            setLoading(false);
            setError(err);
        }

    }
    const handleChange = e => {
        setObj({...obj, [e.target.name]: e.target.value});
        setError({...error, [e.target.name]: false, common_e: ''});
    }
    return(<>
        <div style={{marginTop: 15}}>
            <KpiMiniTable onSelect={()=>{}} fromWelcome={fromWelcome}/>
        </div>
        <Modal isOpen={isOpen} onClose={onClose} size='xl'>
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>Ariza: {selectedParam?.code} — {selectedParam?.title}</ModalHeader>
                <ModalBody>
                    <form onSubmit={createApp} id='apply-form'>
                        <FormControl>
                            <FormLabel>
                                Изоҳ (0/1000)
                            </FormLabel>
                            <Textarea
                                placeholder='Қисқача изоҳ...'
                                size='md'
                                rows={6}
                                onChange={e=>{if(e?.target?.value?.length<=1000) handleChange(e)}}
                                name="work"
                                value={obj?.work??''}
                            />
                            {error?.work?<FormHelperText className='error'>Изоҳни киритинг.</FormHelperText>:''}
                        </FormControl>
                        <br/>
                        <FormControl>
                            <FormLabel>Файллар (PDF, JPG ва ҳ.к.)</FormLabel>
                            <Input type='file' multiple onChange={e=>setFiles(Array.from(e.target.files||[]))} />
                        </FormControl>
                        {error?.common_e?<FormHelperText className='error'>{error?.common_e}</FormHelperText>:''}
                    </form>
                </ModalBody>
                <ModalFooter>
                    <Button mr={3} onClick={onClose}>Bekor qilish</Button>
                    <Button colorScheme='whatsapp' type='submit' form='apply-form' isLoading={loading}>Tasdiqlash</Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    </>)
}
export default AppCreate;